import { useSelector } from "react-redux";
import { Box, Chip, Tooltip } from "@mui/material";
import { entities } from "../../config/config.dataExplorer";

/**
 * Renders the tags for a selected row in the Data Explorer component.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.selectedRow - The selected row object.
 * @returns {JSX.Element} The rendered tags component.
 */
export default function Tags({ selectedRow }) {
  const selectedEntity = useSelector(
    (state) => state.dataExplorer.selectedEntity
  );
  const tagConfig = entities[selectedEntity].tagConfig;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        flexWrap: "wrap",
        mt: 1,
      }}
    >
      {Object.keys(tagConfig || {}).map((key, index) => {
        return selectedRow.row[key] ? (
          <Box
            key={key}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              my: 0.5,
            }}
          >
            <Tooltip
              title={tagConfig[key].label}
              sx={{ color: "primary.contrastText" }}
            >
              {tagConfig[key].icon}
            </Tooltip>
            {selectedRow.row[key]
              .toString()
              ?.split(/[,;]+/)
              .map((chipValue, index) =>
                chipValue ? (
                  <Chip
                    key={`${chipValue}-${index}`}
                    size="small"
                    label={chipValue}
                    sx={{
                      color: "primary.contrastText",
                      backgroundColor: tagConfig[key].color,
                    }}
                  />
                ) : null
              )}
          </Box>
        ) : null;
      })}
    </Box>
  );
}
